import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useGetVendorStaffDetailQuery, useUpdateVendorStaffMutation } from "store/services/vendorStaffApi";
import VendorStaffForm from "./VendorStaffForm";
import { useAuth } from "hooks";


const VendorStaffEditScreen = () => {
  const { id } = useParams();
      const { loggedInUser } = useAuth();
  
  const { from } = useLocation().state || {};
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Vendor Staffs", path: "/app/vendor/staffs/list" },
    from === "detail" && {
      title: "Vendor Staff Detail",
      path: `/app/vendor/staffs/${id}/detail`,
    },
    { title: "Edit Vendor Staff" },
  ].filter(Boolean);

  const { data: vendorStaffDetail, isLoading: loadingVendorStaffDetail } =
    useGetVendorStaffDetailQuery(id);
  const [updateVendorStaff, { isLoading: updatingVendorStaff }] =
  useUpdateVendorStaffMutation();

  const handleVendorStaffUpdate = async (data) => {
    try {
      const formattedData = {
        ...data,
        connectedVendor: loggedInUser?.typeRef,
        role: data?.role?._id
      };
      await updateVendorStaff({ id, ...formattedData }).unwrap();
      navigate(`/app/vendor/staffs/${id}/detail`);
      toast.success("VendorStaff successfully updated!");
    } catch (error) {
      toast.error("VendorStaff update failed! " + error.data?.message);
    }
  };

  return (
    <BreadcrumbLayout
      loading={loadingVendorStaffDetail || updatingVendorStaff}
      breadcrumbs={breadcrumbs}
    >
      <BreadcrumbLayout.Paper>
        <VendorStaffForm
          vendorStaffDetail={vendorStaffDetail}
          isBusy={loadingVendorStaffDetail || updatingVendorStaff}
          onSubmit={handleVendorStaffUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default VendorStaffEditScreen;
